import React from "react";
import {SlidingPanel} from '@cjdev-internal/visual-stack-redux/lib/components/SlidingPanel';
import "./styles/FilterNav.css";

const FilterNav = ({Filters}) => {

    return (
        <div className="filterNavInnerContainer">
            <SlidingPanel initialActive={false}>
                <Filters/>
            </SlidingPanel>
        </div>);
}

export default FilterNav;